export class ShadowMode {
  constructor({ postRecord, mapping }) {
    this.postRecord = postRecord;
    this.mapping = mapping || {};
    this._handler = this._onLegacy.bind(this);
  }

  start() {
    document.addEventListener('cmpEvent', this._handler);
  }

  stop() {
    document.removeEventListener('cmpEvent', this._handler);
  }

  _onLegacy(e) {
    const detail = e.detail || {};
    if (detail.event !== 'consent') return;
    const legacyPurposes = Array.isArray(detail.purposes) ? detail.purposes : [];
    const mapped = legacyPurposes
      .map((p) => this.mapping[p])
      .filter(Boolean);
    this.postRecord({ purposes: mapped, source: 'shadow', legacyRaw: legacyPurposes });
  }
}
